module.exports = __webpack_public_path__ + "img/仅限货机.3e7ef5a6.jpg";